import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { makeRequestQuery } from '@utils/helpers/queryHelpers'
import { IWishListsQueryPaginationPayload } from '@app-store/slices/wishLists/list'
import { contactListQueryMap } from '@utils/QueryMaps'

interface TaskAction extends Action {
    payload: IWishListsQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.wishLists.list

function* listWishListsSagaTask({ payload }: TaskAction) {
    try {
        const query: any = payload.query || makeRequestQuery(contactListQueryMap)

        const params = {
            ...payload.pagination,
            query,
            needPopulate: true,
            populates: [{ path: 'wishedCompanies' }]
        }

        const response = yield axios.get(`/companies/wish-lists`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        }
        if (payload?.sagaCB) {
            payload?.sagaCB?.onSuccess(response.result)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listWishListsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listWishListsSagaTask)
}

export default listWishListsSaga
